import * as DashboardActions from 'app/actions/dasboard/dashboardActions.ts';
import type { PartialListDialogStatisticDto } from '@/api-gen/api.schemas';

export interface IDashboardState {
  dialogStatisticsResponse: { isLoading: boolean; dialogStatistics: PartialListDialogStatisticDto; page: number };
}

const initialState: IDashboardState = {
  dialogStatisticsResponse: { isLoading: false, dialogStatistics: { data: [] }, page: 0 }
};

export const dashboardReducer = (
  state: IDashboardState = initialState,
  action: DashboardActions.Action<DashboardActions.ActionType>
): IDashboardState => {
  switch (action.type) {
    case DashboardActions.ActionType.SetStatisticsLoading: {
      return {
        ...state,
        dialogStatisticsResponse: {
          ...state.dialogStatisticsResponse,
          isLoading: action.payload,
          page: state.dialogStatisticsResponse.page
        }
      };
    }

    case DashboardActions.ActionType.PutDialogStatistics: {
      return {
        ...state,
        dialogStatisticsResponse: {
          ...state.dialogStatisticsResponse,
          dialogStatistics: { ...action.payload },
          page: action.payload.page
        }
      };
    }

    default:
      return state;
  }
};
